import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["humanBtn", "aiBtn", "humanView", "aiView"]

  static values = {
    currentView: { type: String, default: "human" }
  }

  showHuman() {
    this.currentViewValue = "human"
    this.updateView()
  }

  showAi() {
    this.currentViewValue = "ai"
    this.updateView()
  }

  updateView() {
    const isHuman = this.currentViewValue === "human"

    if (this.hasHumanBtnTarget) {
      this.humanBtnTarget.classList.toggle("bg-white", !isHuman)
      this.humanBtnTarget.classList.toggle("text-[#6b7280]", !isHuman)
      this.humanBtnTarget.classList.toggle("bg-[#f2f3f5]", isHuman)
      this.humanBtnTarget.classList.toggle("text-[#1f2937]", isHuman)
    }

    if (this.hasAiBtnTarget) {
      this.aiBtnTarget.classList.toggle("bg-white", isHuman)
      this.aiBtnTarget.classList.toggle("text-[#6b7280]", isHuman)
      this.aiBtnTarget.classList.toggle("bg-[#f2f3f5]", !isHuman)
      this.aiBtnTarget.classList.toggle("text-[#1f2937]", !isHuman)
    }

    if (this.hasHumanViewTarget) {
      this.humanViewTarget.classList.toggle("hidden", !isHuman)
    }

    if (this.hasAiViewTarget) {
      this.aiViewTarget.classList.toggle("hidden", isHuman)
    }
  }
}
